import { Button, styled, Menu, MenuItem } from "@mui/material";

// Shared styled components for breakdown charts
export const GroupByButton = styled(Button)({
    fontSize: "12px",
    color: "#686868",
    fontWeight: 400,
    lineHeight: "12px",
    textTransform: "uppercase",
    maxWidth: "90%",
    borderRadius: "8px",
    border: "none",
    justifyContent: "space-between",

    "&:hover": {
        backgroundColor: "#F0F0F0",
    },

    "& .MuiButton-endIcon": {
        marginLeft: "auto",
        "& .MuiSvgIcon-root": {
            color: "#686868",
            fontSize: "20px !important",
        },
    },
});

export const DropdownMenu = styled(Menu)({
    "& .MuiPaper-root": {
        minWidth: "150px",
        padding: "4px 12px",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)",
        marginTop: "4px",
    },
});

export const GroupByMenuItem = styled(MenuItem)({
    padding: "8px 12px",
    fontWeight: 400,
    fontSize: "14px",
    color: "#3D4B5A",
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    lineHeight: "16px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
        color: "#3D4B5A",
        backgroundColor: "#F9F9F9",
    },
    "&.Mui-selected": {
        fontWeight: 500,
        color: "#4D44D8",
        backgroundColor: "#EFF0FF",
        "&:hover": {
            backgroundColor: "#EFF0FF",
        },
    },
});
